import update from 'immutability-helper'
import React from 'react'
import Text from 'react-text'
import LinesEllipsis from 'react-lines-ellipsis'
import {Link} from 'react-router-dom'
import {faTrashAlt} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {Consumer} from '../../../context'
import confirmDialog from '../../confirm-dialog'
import AddLessons from '../../add-lessons'
import {isUUID} from '../../../helpers/utils'

import './add-lesson.styl'

function Lesson (props) {
  const {id, name, deleteLesson} = props
  return (
    <div className="lesson">
      <div className="content">
        {!isUUID(id) && (<div className="id">{id}</div>)}
        {isUUID(id) && (<div className="id"><Text id="my-lesson" /></div>)}
        <div className="name" title={name}>
          <LinesEllipsis
            text={name}
            maxLine={3}
            ellipsis="..."
            trimRight
            basedOn='letters'
          /> 
        </div>
      </div>
      <div className="actions">
        <div className="delete" onClick={deleteLesson}>
          <FontAwesomeIcon icon={faTrashAlt} />
        </div>
      </div>
    </div>
  )
}

export default function AddLesson () {

  return (<Consumer>{ context => {
    const {newPlan, languageId, link} = context
    const {content = {}} = newPlan
    const {lessons = []} = content

    const deleteLesson = (index, title) => {
      return () => {
        confirmDialog({
          className: 'delete-field',
          translate: context.translate,
          children: (
            <div className="message">
              <div className="question">
                {context.translate('confirm_delete_item')}
              </div>
              <div className="title">
                {title}
              </div>
            </div>
          ),
          onConfirm: () => {
            const lessons = update(newPlan.content.lessons, {$splice: [[index,1]]})
            context.setState({newPlan: {...newPlan, content: {...content, lessons}}})
          }
        })
      }
    }

    const items = lessons.map((lesson, index) => {
      return (
        <Lesson
          key={index}
          index={index}
          className="lesson"
          deleteLesson={deleteLesson(index, lesson.name)}
          context={context}
          {...lesson}
        />
      )
    })

    return (
      <div className="lessons">
        { context.section == 'add-lessons' && (<AddLessons activeTab='catalogue' />)}
        <div className="head">
          <label><Text id="lessons_label" /></label>
          <Link
            className="add-lesson"
            to={context.link({section: 'add-lessons', activeTab: 'catalogue'}, context.match.path, {preserveQuery: true})}
          >
            +
          </Link>
        </div>
        { items.length > 0 && (
          <div className="content">
            {items}
          </div>
        )}
      </div>
    )}}</Consumer>)
}
